import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PublicHeader />
      <main className="pt-16 flex-grow">{children}</main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
